<template>
  <span>
    <!-- Save to projects pop up -->
    <b-modal
      id="saveto-project"
      ref="modal"
      title="Save to Projects"
      title-tag="h3"
      ok-only
      modal-class="common_pop saveto_project"
    >
      <div
        v-if="!showclient && !shownewproject && !shownewclient"
        class="projectoptions"
      >
        <h3>Save to Projects</h3>
        <ul>
          <li>
            <a href="javascript:;" @click="showclient = !showclient"
              >Existing Client - Existing Project</a
            >
          </li>
          <li>
            <a href="javascript:;" @click="shownewproject = !shownewproject"
              >Existing Client - New Project</a
            >
          </li>
          <li>
            <a href="javascript:;" @click="shownewclient = !shownewclient"
              >New Client- New Project</a
            >
          </li>
        </ul>
      </div>
      <div v-if="showclient" class="savetoclient">
        <a
          @click="
            showclient = !showclient;
            resetModelForm();
          "
          href="javascript:;"
        >
          <b-img
            class="slidearrow"
            src="/shop/images/arrow.svg"
            fluid
            alt="arrow image"
          ></b-img
          >Back
        </a>
        <h3>Save to Existing Client- Project</h3>
        <b-form class="commonform" @submit="Submit1Popup">
          <div class="row">
            <div
              class="col"
              :state="!form1.errors.has('client')"
              :class="
                form1.errors.get('client') ? 'haserror forstar' : 'forstar'
              "
              :invalid-feedback="form1.errors.get('client')"
            >
              <label class="setuplabel">Select a Client</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form1.errors.has('client')"
                  @input="
                    form1.errors.clear('client');
                    getProjects();
                  "
                  :options="clientscart"
                  :reduce="(clientscart) => clientscart.value"
                  label="text"
                  v-model="form1.client"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form1.errors.get('client')"
                  >Required Field</span
                >
              </div>
            </div>
          </div>
          <div v-show="showProject" class="row">
            <div
              class="col"
              :state="!form1.errors.has('project')"
              :class="
                form1.errors.get('project') ? 'haserror forstar' : 'forstar'
              "
              :invalid-feedback="form1.errors.get('project')"
            >
              <label class="setuplabel">Select a Project</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form1.errors.has('project')"
                  @input="form1.errors.clear('project')"
                  :options="projects"
                  :reduce="(projects) => projects.value"
                  label="text"
                  v-model="form1.project"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form1.errors.get('project')"
                  >Required Field</span
                >
              </div>
            </div>
          </div>
          <b-button block type="submit" variant="dark">Add</b-button>
          <span class="error-msg" v-if="this.form1.error_name != ''">{{
            this.form1.error_name
          }}</span>
        </b-form>
      </div>
      <div v-if="shownewproject" class="savetoclient">
        <a
          @click="
            shownewproject = !shownewproject;
            resetModelForm();
          "
          href="javascript:;"
        >
          <b-img
            class="slidearrow"
            src="/shop/images/arrow.svg"
            fluid
            alt="arrow image"
          ></b-img
          >Back
        </a>
        <h3>Save to New Project of Existing Client</h3>
        <b-form class="commonform" @submit="Submit2Popup">
          <div class="row">
            <div
              class="col"
              :state="!form2.errors.has('client_id')"
              :class="
                form2.errors.get('client_id') ? 'haserror forstar' : 'forstar'
              "
              :invalid-feedback="form2.errors.get('client_id')"
            >
              <label class="setuplabel">Select a Client</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form2.errors.has('client_id')"
                  @input="
                    form2.errors.clear('client_id');
                    showProject1();
                  "
                  :options="clientscart"
                  :reduce="(clientscart) => clientscart.value"
                  label="text"
                  v-model="form2.client_id"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form2.errors.get('client_id')"
                  >Required Field</span
                >
              </div>
            </div>
          </div>
          <div v-show="showProject1a" class="row">
            <div class="col">
              <md-field
                :state="!form2.errors.has('name')"
                :class="
                  form2.errors.get('name') ? 'haserror forstar' : 'forstar'
                "
                :invalid-feedback="form2.errors.get('name')"
              >
                <label class="setuplabel">Create and save to new project</label>
                <md-input
                  :state="!form2.errors.has('name')"
                  @input="form2.errors.clear('name')"
                  v-model="form2.name"
                ></md-input>

                <span class="error-msg" v-if="form2.errors.get('name')">{{
                  form2.errors.get("name") == "The name field is required."
                    ? "Required Field"
                    : form2.errors.get("name")
                }}</span>
              </md-field>
            </div>
          </div>
          <b-button block type="submit" variant="dark">Add</b-button>
          <span class="error-msg" v-if="this.form2.error_name != ''">{{
            this.form2.error_name
          }}</span>
        </b-form>
      </div>
      <div v-if="shownewclient" class="savetoclient newcreation">
        <a
          @click="
            shownewclient = !shownewclient;
            resetModelForm();
          "
          href="javascript:;"
        >
          <b-img
            class="slidearrow"
            src="/shop/images/arrow.svg"
            fluid
            alt="arrow image"
          ></b-img
          >Back
        </a>
        <h3>Save to New Client- Project</h3>
        <b-form class="commonform" @submit="Submit3Popup">
          <md-field
            :state="!form.errors.has('createclient')"
            :class="
              form.errors.get('createclient') ? 'haserror forstar' : 'forstar'
            "
            :invalid-feedback="form.errors.get('createclient')"
          >
            <label>Create a new client</label>
            <md-input
              :state="!form.errors.has('createclient')"
              @input="
                form.errors.clear('createclient');
                showProject2();
              "
              v-model="form.createclient"
            ></md-input>
            <span class="error-msg" v-if="form.errors.get('createclient')">{{
              form.errors.get("createclient") ==
              "The createclient field is required."
                ? "Required Field"
                : form.errors.get("createclient")
            }}</span>
          </md-field>
          <md-field
          v-show="showProject2a"
            :state="!form.errors.has('createproject')"
            :class="
              form.errors.get('createproject')
                ? 'haserror forstar'
                : 'forstar'
            "
            :invalid-feedback="form.errors.get('createproject')"
          >
            <label>Create a new project</label>
            <md-input
              :state="!form.errors.has('createproject')"
              @input="form.errors.clear('createproject')"
              v-model="form.createproject"
            ></md-input>
            <span class="error-msg" v-if="form.errors.get('createproject')">{{
              form.errors.get("createproject") ==
              "The createproject field is required."
                ? "Required Field"
                : form.errors.get("createproject")
            }}</span>
          </md-field>
          <b-button block type="submit" variant="dark">Add</b-button>
          <span class="error-msg" v-if="this.form.error_name != ''">{{
            this.form.error_name
          }}</span>
        </b-form>
      </div>
    </b-modal>
    <b-modal
      id="success-save-project"
      ref="successmodal"
      :title="this.successtitle"
      title-tag="h3"
      ok-only
      modal-class="common_pop save_project"
    >
    <a href="/shop/projects" class="btn btn-dark view-proj">View Projects</a>
    </b-modal>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    "v-select": vSelect,
  },
  mounted() {
    this.LoadClients();
  },
  data() {
    return {
      showProject1a: false,
      showProject2a: false,
      showProject: false,
      showclient: false,
      shownewproject: false,
      shownewclient: false,
      successtitle: "",
      clientscart: [],
      projects: [],
      form: new Form({
        createclient:"",
        createproject: "",
        product_id: "",
        order_type: "CDI",
        pc_type:"CDI",
        user_id: "",
        cart: "",
        error_name: "",
      }),
      form1: new Form({
        client: "",
        project: "",
        product_id: "",
        order_type: "CDI",
        pc_type:"CDI",
        cart: "",
        user_id: "",
        error_name: "",
      }),
      form2: new Form({
        client_id: "",
        name: "",
        project: "",
        product_id: "",
        order_type: "CDI",
        pc_type:"CDI",
        cart: "",
        user_id: "",
        error_name: "",
      }),
      id: "",
      ispleated: false,
      isQuickship: false,
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    reset() {
      this.showProject = false;
      this.showclient = false;
      this.shownewproject = false;
      this.shownewclient = false;
    },
    hide() {
      this.$refs["modal"].hide();
    },
    show(id,type) {
      if (id) {
        this.id = id;
        if(type == '1'){
          this.ispleated = true;
        }
        if(type == '2'){
          this.isQuickship = true;
        }
        this.$refs["modal"].show();
      }
    },
    Submit1Popup(evt) {
      evt.preventDefault();
      this.form1.product_id = this.id;
      this.form1.order_type = "CDI";
      if(this.ispleated == true){
        this.form1.pc_type = "CDIP";
        this.form1.order_type = "CDI";
      }
      if(this.isQuickship == true){
        this.form1.pc_type = "CDIQ";
        this.form1.order_type = "CDI";
      }
      this.$store
        .dispatch("AddProductToProject", {
          form: this.form1,
        })
        .then((response) => {
          if (response.data.success) {
            this.form1.error_name = "";
            if(this.ispleated == true){
              this.$notify({
                text: "Pleated Program added successfully",
                type: "success",
              });
            }else if(this.isQuickship == true){
                this.$notify({
                  text: "Quick Ship added successfully",
                  type: "success",
                });
            }else{
              this.$notify({
                text: "Promo Program added successfully",
                type: "success",
              });
            }
            this.form1 = new Form({
              client: null,
              project: null,
              error_name: "",
              product_id: "",
              order_type: "CDI",
              pc_type:"CDI",
            });

            this.hide();
            this.reset();
            if(this.ispleated == true){
              this.successtitle = "Pleated Program added successfully";
            }else if(this.isQuickship == true){
              this.successtitle = "Quick Ship added successfully";
            }else{
              this.successtitle = "Promo Program added successfully";
            }
            this.$refs["successmodal"].show();
          } else {
            this.$notify({
              text: "please try again!",
              type: "error",
            });

            this.form1.error_name = response.data.error;
          }
        });
    },
    Submit2Popup(evt) {
      evt.preventDefault();
      this.form2.product_id = this.id;
      this.form2.order_type = "CDI";
      if(this.ispleated == true){
        this.form2.pc_type = "CDIP";
        this.form2.order_type = "CDI";
      }
      if(this.isQuickship == true){
        this.form2.pc_type = "CDIQ";
        this.form2.order_type = "CDI";
      }
      this.$store
        .dispatch("AddProject", {
          form: this.form2,
        })
        .then((response) => {
          if (response.data.success) {
            this.form2.error_name = "";
            if(this.ispleated == true){
              this.$notify({
                text: "Pleated Program added successfully",
                type: "success",
              });
            }else if(this.isQuickship == true){
                this.$notify({
                  text: "Quick Ship added successfully",
                  type: "success",
                });
            }else{
              this.$notify({
                text: "Promo Program added successfully",
                type: "success",
              });
            }
            this.form2 = new Form({
              client_id: "",
              name: "",
              project: null,
              error_name: "",
              product_id: "",
              order_type: "CDI",
              pc_type:"CDI",
            });

            this.hide();
            this.reset();
            if(this.ispleated == true){
              this.successtitle = "Pleated Program added successfully";
            }else if(this.isQuickship == true){
              this.successtitle = "Quick Ship added successfully";
            }else{
              this.successtitle = "Promo Program added successfully";
            }
            this.$refs["successmodal"].show();
          } else {
            this.$notify({
              text: "please try again!",
              type: "error",
            });

            this.form2.error_name = response.data.error;
          }
        });
      this.isLoading = false;
    },
    Submit3Popup(evt) {
      evt.preventDefault();

      this.form.product_id = this.id;
      this.form.order_type = "CDI";
      if(this.ispleated == true){
        this.form.pc_type = "CDIP";
        this.form.order_type = "CDI";
      }
      if(this.isQuickship == true){
        this.form.pc_type = "CDIQ";
        this.form.order_type = "CDI";
      }
      this.form.user_id = this.user.accountnumber;
      this.$store
        .dispatch("AddClientAndProject", {
          form: this.form,
        })
        .then((response) => {
          if (response.data.success) {
            //update clients dropdown
            this.LoadClients();
            this.form.error_name = "";
            if(this.ispleated == true){
              this.$notify({
                text: "Pleated Program added successfully",
                type: "success",
              });
            }else if(this.isQuickship == true){
                this.$notify({
                  text: "Quick Ship added successfully",
                  type: "success",
                });
            }else{
              this.$notify({
                text: "Promo Program added successfully",
                type: "success",
              });
            }
            this.form = new Form({
              createclient: null,
              createproject: null,
              error_name: "",
              product_id: null,
              order_type: null,
              user_id: null,
              pc_type:"CDI",
            });

            this.hide();
            this.reset();
            if(this.ispleated == true){
              this.successtitle = "Pleated Program added successfully";
            }else if(this.isQuickship == true){
              this.successtitle = "Quick Ship added successfully";
            }else{
              this.successtitle = "Product added successfully";
            }
            this.$refs["successmodal"].show();
          } else {
            this.$notify({
              text: "please try again!",
              type: "error",
            });

            this.form.error_name = response.data.error;
          }
        });
      this.isLoading = false;
    },
    LoadClients() {
      if (this.user.id > 0) {
        this.$store
          .dispatch("LoadClient", this.user.accountnumber)
          .then((loadclients) => {
            this.clientscart = loadclients.data;
          });
      }
    },
    getProjects() {
      if (this.form1.client) {
        this.showProject = true;
        // $(".showProject").show();
        this.$store
          .dispatch("LoadClientProjects", this.form1.client)
          .then((loadprojects) => {
            this.projects = loadprojects.data;
          });
      } else {
        ths.showProject = false;
      }
    },
    showProject1() {
      if (this.form2.client_id) {
        this.showProject1a = true;
      } else {
        this.showProject1a = false;
      }
    },
        showProject2() {
      if (this.form.createclient) {
        this.showProject2a = true;
      } else {
        this.showProject2a = false;
      }
    }
  },
};
</script>
<style>
</style>